/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { TickerLotDto } from '../models/ticker-lot-dto';

@Injectable({
  providedIn: 'root',
})
export class GeneratedTickerLotService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getTickerLot
   */
  static readonly GetTickerLotPath = '/api/ticker/lots/{id}';

  /**
   * Gets a lot by its id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTickerLot()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTickerLot$Response(params: {
    id: number;
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<TickerLotDto>> {

    const rb = new RequestBuilder(this.rootUrl, GeneratedTickerLotService.GetTickerLotPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.header('X-API-Version', params['X-API-Version'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TickerLotDto>;
      })
    );
  }

  /**
   * Gets a lot by its id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getTickerLot$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTickerLot(params: {
    id: number;
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<TickerLotDto> {

    return this.getTickerLot$Response(params,context).pipe(
      map((r: StrictHttpResponse<TickerLotDto>) => r.body as TickerLotDto)
    );
  }

}
